import React, { useEffect, useState } from "react";
import { Image, notification } from "antd";
import {
  CheckCircleOutlined,
  InfoCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import {
  addeditdata,
  list,
} from "../../../controllers/V1/cms/generalDataController";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import ImageUploader from "../../../components/ImageUploader/ImgUploader";
import { ASSETS_BASE_URL } from "../../../config/constants";

const GeneralAddEditData = () => {
  const ADMINUSER = JSON.parse(localStorage.getItem("ADMIN-INFO"));
  const eCommFieldSets = [
    {
      label: "Phone",
      name: "ecommerce_phone",
      required: true,
      size: "4",
      type: "text",
    },
    {
      label: "WhatsApp No",
      name: "ecommerce_whatsapp_no",
      size: "4",
      type: "text",
    },
    {
      label: "Email",
      name: "ecommerce_email",
      required: true,
      size: "4",
      type: "text",
    },
    {
      label: "Company Name",
      name: "ecommerce_company_name",
      required: true,
      type: "text",
      size: "12",
    },
    {
      label: "Website",
      name: "ecommerce_website",
      required: true,
      type: "text",
      size: "12",
    },
  ];

  const generalFieldSets = [
    {
      label: "Phone",
      name: "phone",
      required: true,
      size: "4",
      type: "text",
    },
    {
      label: "WhatsApp No",
      name: "whatsapp_no",
      size: "4",
      type: "text",
    },
    {
      label: "Email",
      name: "email",
      required: true,
      size: "4",
      type: "text",
    },
    {
      label: "Company Name",
      name: "company_name",
      required: true,
      type: "text",
      size: "12",
    },
    {
      label: "Address",
      name: "address", 
      required: true, 
      size: "12",
      type: "text" 
    },
    { 
      label: "Facebook Link", 
      name: "facebook_link", 
      size: "4",
      type: "text" 
    },
    { 
      label: "LinkedIn Link", 
      name: "linkedin_link", 
      size: "4",
      type: "text" 
    },
    { 
      label: "Twitter Link", 
      name: "twitter_link", 
      size: "4",
      type: "text" 
    },
    { 
      label: "Instagram Link", 
      name: "insta_link", 
      size: "4",
      type: "text" 
    },
    { 
      label: "YouTube Link", 
      name: "you_tube", 
      size: "4",
      type: "text" 
    },
    { 
      label: "Website", 
      name: "website", 
      size: "4",
      type: "text" 
    },
    ...(ADMINUSER?.admin_type === "Super Admin"
      ? [
          {
            label: "Export Start Time",
            name: "export_start_time",
            size: "3",
            type: "time",
            required: true,
          },
          {
            label: "Export End Time",
            name: "export_end_time",
            size: "3",
            type: "time",
            required: true,
          },
          { 
            label: "Report Start Time", 
            name: "draw_start_time", 
            size: "3",
            type: "time",
            required: true,
          },
          { 
            label: "Report End Time",
            name: "draw_end_time", 
            size: "3",
            type: "time",
            required: true,
          },
          { 
            label: "Analyser Cc-Emails",
            name: "analyser_emails", 
            size: "12",
            type: "text",
            required: false,
          },
          {
            label: "Analyser Start Time",
            name: "analyser_start_time",
            size: "3",
            type: "time",
            required: true,
          },
          { 
            label: "Analyser End Time", 
            name: "analyser_end_time", 
            size: "3",
            type: "time",
            required: true,
          },
          {
            label: "Invoice Start Time",
            name: "invoice_start_time",
            size: "3",
            type: "time",
            required: true,
          },
          { 
            label: "Invoice End Time", 
            name: "invoice_end_time", 
            size: "3",
            type: "time", 
            required: true,
          },
          {
            label: "Mask Lotto Ticket ID ",
            name: "show_lotto_ticket_id",
            size: "3",
            type: "select",
          },
          {
            label: "Redeem 2FA",
            name: "redeem_2fa",
            size: "3",
            type: "select",
          },
          { 
            label: "Show POS No.", 
            name: "showPosNo", 
            size: "3", 
            type: "select" 
          },
          { 
            label: "Show Store Name", 
            name: "showStoreName", 
            size: "3", 
            type: "select" 
          },
          { 
            label: "Third Party Logs", 
            name: "third_party_logs", 
            size: "3", 
            type: "select" 
          },
          { 
            label: "RTP Reprint Time", 
            name: "rtp_reprint_time", 
            size: "3", 
            type: "number" 
          },
        ]
      : []),
    { 
      label: "Lotto Default Pin", 
      name: "lotto_default_pin", 
      size: "3",
      type: "number",
      required: true,
    },
    { 
      label: "Trade License", 
      name: "trade_license", 
      size: "3",
      type: "text"
    },
    {
      label: "Raffle Coupon",
      name: "raffle_coupon",
      size: "3",
      type: "select",
    },
    {
      label: "Raffle Range (In Days)",
      name: "raffle_range",
      size: "3",
      type: "number",
    },
    { 
      label: "Result Menu", 
      name: "result_menu", 
      size: "3", 
      type: "select" 
    },
  ];
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showUploader, setShowUploader] = useState(false);
  const toggleImgUploader = () => setShowUploader(!showUploader);
  const [data, setData] = useState({});
  const [imageUrl, setImageUrl] = useState(data?.trade_license_url || "");

  /*********************************************************
   *  This function is used to handle input changes
   *********************************************************/
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    setError((prev) => ({ ...prev, [name]: "" }));
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = () => {
    const { phone, email, address } = data;
    let isValid = true;
    const newErrors = {};

    if (!phone || phone.trim() === "") {
      newErrors.phone = "Phone number is required.";
      isValid = false;
    }

    if (!email || email.trim() === "") {
      newErrors.email = "Email is required.";
      isValid = false;
    }

    if (!address || address.trim() === "") {
      newErrors.address = "Address is required.";
      isValid = false;
    }

    setError(newErrors);
    return isValid;
  };

  /*********************************************************
   *  This function is used to handle form submission
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateFormData()) return;

    try {
      setIsLoading(true);
      const cleanedData = {
        ...Object.fromEntries(
          Object.entries(data).filter(
            ([_, value]) => typeof value === "string" && value.trim() !== ""
          )
        ),
        trade_license_url: imageUrl || "", // Add the image key with its URL
      };

      const res = await addeditdata(cleanedData);

      if (res.status === true) {
        notification.open({
          message: "Success.",
          description: `Data successfully added/updated.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
      } else {
        notification.open({
          message: "Error.",
          description: `${res.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.error("Error during submission:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getList = async () => {
    try {
      setIsLoading(true);
      const options = {
        type: "",
      };
      const listData = await list(options);
      if (listData.status === true) {
        setData(listData?.result);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    getList();
  }, []);

  const renderFields = (fields) =>
    fields.map(({ label, name, required, size, type }) => (
      <div
        key={name}
        className={`form-group col-lg-${size} col-md-${size} col-sm-12 col-xs-12 mb-3`}
      >
        <label>
          {required && <span style={{ color: "red" }}>*</span>} {label}:
        </label>
        {type === "select" ? (
          <select
            name={name}
            value={
              String(data?.[name] || "").toLowerCase() === "enable"
                ? "Enable"
                : "Disable"
            }
            onChange={handleChange}
            className="form-control"
          >
            <option value="Enable">Enable</option>
            <option value="Disable">Disable</option>
          </select>
        ) : (
          <input
            type={type ? type : "text"}
            name={name}
            className="form-control"
            value={data[name] || ""}
            onChange={handleChange}
            placeholder={`Enter ${label?.toLowerCase()}`}
          />
        )}
        {error[name] && <p style={{ color: "red" }}>{error[name]}</p>}
      </div>
    ));

  return (
    <div className="container-fluid">
      <div className="Inventory_edit_page_main_div">
        <h5 className="inventory_edit_page_heading">
          {data._id ? "Edit" : "Add"} General Data
        </h5>
        <Link to="/dashboard">
          <button type="button" className="btn btn-secondary">
            <ArrowLeftOutlined /> Back
          </button>
        </Link>
      </div>

      <form method="post" onSubmit={handleSubmit}>
        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-header py-3 invetory_title_div">
            <h6 className="m-0 font-weight-bold text-black">E-Commerce</h6>
          </div>
          <div className="card-body">
            <div className="row">{renderFields(eCommFieldSets)}</div>
          </div>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-header py-3 invetory_title_div">
            <h6 className="m-0 font-weight-bold text-black">Common Settings</h6>
          </div>  
          <div className="card-body">
            <div className="row">{renderFields(generalFieldSets)}</div>

            <div className="row">
              <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data">
                <label htmlFor="trade_license_url">
                  <span style={{ color: "red" }}>*</span> Image:
                </label>
                {/* Hidden input to store the image URL */}
                <input
                  type="hidden"
                  value={imageUrl || ""}
                  name="trade_license_url"
                  id="image"
                />
                {/* Button to open image uploader */}
                <button
                  type="button"
                  className="form-control"
                  onClick={toggleImgUploader}
                >
                  Select Image
                </button>
              </div>

              {/* Display selected image */}
              <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data">
                {imageUrl || data?.trade_license_url ? (
                  <Image
                    src={`${ASSETS_BASE_URL}${
                      imageUrl || data?.trade_license_url
                    }`}
                    width="100px"
                    alt="Selected Preview"
                  />
                ) : (
                  <p>No image selected</p>
                )}
              </div>

              {/* <div className="form-group col-lg-3 col-md-3 col-sm-12 col-xs-12 vendor_Add_edit_data">
                  {imageUrl || data&& (
                      <span>
                        <img src={`${ASSETS_BASE_URL}${imageUrl}`} width={'100px'}/>
                      </span>
                    )}
                    </div> */}
              <div className="form-group col-lg-12 text-center mt-4">
                <button
                  type="submit"
                  className="btn btn-primary inventory_save_button"
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <ImageUploader
        openUpload={showUploader}
        toggleUploadOpen={toggleImgUploader}
        setImgUrl={setImageUrl}
      />

      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default GeneralAddEditData;
